import React from 'react';
import ResultWr from '../../containers/payoutsAndResultsContainer/resultWr';

function MobileResultContainer() {
  return (
    <div className='pgc-result-has-last-card-holder-mobile'>
      <ResultWr isShowResultTitles resultTitles={['ROUND_ID', 'RESULT', 'CHECK']} />
    </div>
  );
}
export default MobileResultContainer;
